export const checkIfPresentInStateGroups = code => {
  if (code === 'WA' || code === 'OR') {
    if (code === 'WA') {
      return 'WA/OR';
    }
    return ''
  }
  if (code === 'ND' || code === 'SD') {
    if (code === 'ND') {
      return 'ND/SD'
    }
    return ''
  }
  if (code === 'NE' || code === 'KS') {
    if (code === 'NE') {
      return 'NE/KS'
    }
    return ''
  }
  if (code === 'MN' || code === 'IA') {
    if (code === 'MN') {
      return 'MN/IA'
    }
    return ''
  }
  if (code === 'AL' || code === 'MS') {
    if (code === 'AL') {
      return 'AL/MS'
    }
    return ''
  }
  if (code === 'NC' || code === 'SC') {
    if (code === 'NC') {
      return 'NC/SC'
    }
    return ''
  }
  if (code === 'CT' || code === 'RI') {
    if (code === 'CT') {
      return 'CT/RI'
    }
    return ''
  }
  if (code === 'AZ' || code === 'UT' || code === 'NM' || code === 'NV') {
    if (code === 'UT') {
      return 'AZ/UT/NM/NV'
    }
    return ''
  }
  if (code === 'MT' || code === 'WY' || code === 'ID' || code === 'CO') {
    if (code === 'WY') {
      return 'MT/WY/ID/CO'
    }
    return ''
  }
  if (code === 'DC' || code === 'DE' || code === 'MD' || code === 'WV') {
    if (code === 'DC') {
      return 'WV/MD/DE/DC'
    }
    return ''
  }
  if (code === 'OK' || code === 'AR' || code === 'LA') {
    if (code === 'OK') {
      return 'OK/AR/LA'
    }
    return ''
  }
  if (code === 'ME' || code === 'VT' || code === 'NH') {
    if (code === 'ME') {
      return 'ME/VT/NH'
    }
    return ''
  }
  return code
}

export const getFormatForQRMap = (mapData, view, geoLabel, indexLabel) => {
  const self = mapData;
  if (view === 'Census Regions') {
    if (self.point.properties && geoLabel && indexLabel) {
      const finalVal = self.point.value ? self.point.value : '';
      return self.point.properties['hc-a2'] === 'UT'
        ? `West <br> ${finalVal}`
        : self.point.properties['hc-a2'] === 'IA'
        ? `Midwest <br> ${finalVal}`
        : self.point.properties['hc-a2'] === 'MS'
        ? `South <br> ${finalVal}`
        : self.point.properties['hc-a2'] === 'NY'
        ? `Northeast <br> ${finalVal}`
        : '';
    }
    if (self.point.properties && indexLabel) {
      const finalVal = self.point.value ? self.point.value : '';
      return self.point.properties['hc-a2'] === 'UT'
        ? finalVal
        : self.point.properties['hc-a2'] === 'IA'
        ? finalVal
        : self.point.properties['hc-a2'] === 'MS'
        ? finalVal
        : self.point.properties['hc-a2'] === 'NY'
        ? finalVal
        : '';
    }
    if (self.point.properties && geoLabel) {
      return self.point.properties['hc-a2'] === 'UT'
        ? 'West'
        : self.point.properties['hc-a2'] === 'IA'
        ? 'Midwest'
        : self.point.properties['hc-a2'] === 'MS'
        ? 'South'
        : self.point.properties['hc-a2'] === 'NY'
        ? 'Northeast'
        : '';
    }
    return '';
  }
  if (view === 'Nielsen Regions') {
    if (self.point.properties && geoLabel && indexLabel) {
      const finalVal = self.point.value ? self.point.value : '';
      return self.point.properties['hc-a2'] === 'NV'
        ? `Pacific <br> ${finalVal}`
        : self.point.properties['hc-a2'] === 'SD'
        ? `West Central <br> ${finalVal}`
        : self.point.properties['hc-a2'] === 'MS'
        ? `South <br> ${finalVal}`
        : self.point.properties['hc-a2'] === 'OH'
        ? `East Central <br> ${finalVal}`
        : self.point.properties['hc-a2'] === 'NY'
        ? `Northeast <br> ${finalVal}`
        : '';
    }
    if (self.point.properties && indexLabel) {
      const finalVal = self.point.value ? self.point.value : '';
      return self.point.properties['hc-a2'] === 'NV'
        ? finalVal
        : self.point.properties['hc-a2'] === 'SD'
        ? finalVal
        : self.point.properties['hc-a2'] === 'MS'
        ? finalVal
        : self.point.properties['hc-a2'] === 'OH'
        ? finalVal
        : self.point.properties['hc-a2'] === 'NY'
        ? finalVal
        : '';
    }
    if (self.point.properties && geoLabel) {
      return self.point.properties['hc-a2'] === 'NV'
        ? 'Pacific'
        : self.point.properties['hc-a2'] === 'SD'
        ? 'West Central'
        : self.point.properties['hc-a2'] === 'MS'
        ? 'South'
        : self.point.properties['hc-a2'] === 'OH'
        ? 'East Central'
        : self.point.properties['hc-a2'] === 'NY'
        ? 'Northeast'
        : '';
    }
    return '';
  }
  if (view === 'Marketing Regions') {
    if (self.point.properties && geoLabel && indexLabel) {
      const finalVal = self.point.value ? self.point.value : '';
      return self.point.properties['hc-a2'] === 'NV'
        ? `Pacific <br> ${finalVal}`
        : self.point.properties['hc-a2'] === 'SD'
        ? `West Central <br> ${finalVal}`
        : self.point.properties['hc-a2'] === 'TX'
        ? `South West <br> ${finalVal}`
        : self.point.properties['hc-a2'] === 'AL'
        ? `South East <br> ${finalVal}`
        : self.point.properties['hc-a2'] === 'OH'
        ? `East Central <br> ${finalVal}`
        : self.point.properties['hc-a2'] === 'NY'
        ? `Middle Atlantic <br> ${finalVal}`
        : self.point.properties['hc-a2'] === 'ME'
        ? `New England <br> ${finalVal}`
        : '';
    }
    if (self.point.properties && indexLabel) {
      const finalVal = self.point.value ? self.point.value : '';
      return self.point.properties['hc-a2'] === 'NV'
        ? finalVal
        : self.point.properties['hc-a2'] === 'SD'
        ? finalVal
        : self.point.properties['hc-a2'] === 'MS'
        ? finalVal
        : self.point.properties['hc-a2'] === 'OH'
        ? finalVal
        : self.point.properties['hc-a2'] === 'NY'
        ? finalVal
        : '';
    }
    if (self.point.properties && geoLabel) {
      return self.point.properties['hc-a2'] === 'NV'
        ? 'Pacific'
        : self.point.properties['hc-a2'] === 'SD'
        ? 'West Central'
        : self.point.properties['hc-a2'] === 'TX'
        ? 'South West'
        : self.point.properties['hc-a2'] === 'AL'
        ? 'South East'
        : self.point.properties['hc-a2'] === 'OH'
        ? 'East Central'
        : self.point.properties['hc-a2'] === 'NY'
        ? 'Middle Atlantic'
        : self.point.properties['hc-a2'] === 'ME'
        ? 'New England'
        : '';
    }
    return '';
  }
  if (view === 'State Groups') {
    if (self.point.properties && geoLabel && indexLabel) {
      const finalVal = self.point.value ? self.point.value : '';
      const label = checkIfPresentInStateGroups(self.point.properties['hc-a2'])
      return label ? `${label} <br> ${finalVal}` : '';
    }
    if (self.point.properties && indexLabel) {
      const finalVal = self.point.value ? self.point.value : '';
      const label = checkIfPresentInStateGroups(self.point.properties['hc-a2'])
      return label ? finalVal : '';
    }
    if (self.point.properties && geoLabel) {
      const label = checkIfPresentInStateGroups(self.point.properties['hc-a2'])
      return label
    }
    return '';
  }
  if (view === 'States') {
    const finalVal = self.point.value ? self.point.value : '';
    if (self.point.properties) {
      return geoLabel && indexLabel
        ? `${self.point.properties['hc-a2']} <br> ${finalVal}`
        : indexLabel
        ? finalVal
        : geoLabel
        ? self.point.properties['hc-a2']
        : '';
    }
    return '';
  }
  return '';
}